module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(!_vm.isLoggedIn) ? _c('h1', {
    staticClass: "center-align"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://mfind-production.s3.eu-central-1.amazonaws.com/images/punkta_white.png",
      "alt": "punkta"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('nav', [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://mfind-production.s3.eu-central-1.amazonaws.com/images/punkta_white.png",
      "alt": "punkta"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-links hide-on-med-and-down"
  }, _vm._l((_vm.navLinks), function(link) {
    return _c('router-link', {
      key: link.routerName,
      attrs: {
        "to": {
          name: link.routerName
        },
        "active-class": "active",
        "exact": ""
      }
    }, [_vm._v("\n          " + _vm._s(link.name) + "\n        ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "menu-right"
  }, [(_vm.showSpecialToolsLink) ? _c('div', {
    staticClass: "money-and-share-link left"
  }, [_c('money-info', {
    staticClass: "left"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": {
        name: 'tools'
      }
    }
  }, [_vm._v("NARZĘDZIA")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-overlay btn-logout hide-on-med-and-down",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Wyloguj")]), _vm._v(" "), _vm._m(0)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('ul', {
    staticClass: "slide-nav fixed right hide-on-large-only show-on-medium-and-down",
    attrs: {
      "id": "slide-out-nav"
    }
  }, [_c('li', {
    staticClass: "no-divider"
  }, [_c('a', {
    staticClass: "btn btn-overlay btn-logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Wyloguj")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.showSpecialToolsLink) ? _c('li', {
    staticClass: "money-container no-divider"
  }, [_c('money-info', {
    staticClass: "left"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn right",
    attrs: {
      "to": {
        name: 'tools'
      }
    }
  }, [_vm._v("NARZĘDZIA")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "no-divider"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1)]), _vm._v(" "), _vm._l((_vm.navLinks), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: link.routerName
        },
        "active-class": "active",
        "exact": ""
      }
    }, [_vm._v("\n        " + _vm._s(link.name) + "\n      ")])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "no-divider"
  }, [_c('contact')], 1), _vm._v(" "), _c('li', {
    staticClass: "no-divider"
  }, [_c('find-us')], 1)], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-collapse right show-on-medium-and-down",
    attrs: {
      "href": "#",
      "data-activates": "slide-out-nav"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-menu"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-close"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20b5ffac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerBar/headerBar.vue
// module id = 363
// module chunks = 0